import { Request } from 'common/domain/models/request';

class RequestQuestionController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.dayClicked = this.startDate;
  }

  chooseVacation() {
    this.onSelection(this.EventEmitter({ type: Request.TYPES.VACATION }));
  }

  chooseAbsence() {
    this.onSelection(this.EventEmitter({ type: Request.TYPES.ABSENCE }));
  }

  /**
   * Regla confirmada por BBVA en el Jira 12071
   * - Se permite seleccionar el mes anterior SOLO hasta el día 17 (incluido) del mes actual.
   * - Mes actual y futuros: permitido.
   * - Más antiguo que el mes anterior: no permitido.
   */
  isPreviousMonthNotAllowed() {
    if (!this.startDate) return false;

    const now = new Date();
    const selected = this.startDate;

    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth();

    const selectedYear = selected.getFullYear();
    const selectedMonth = selected.getMonth();

    const nowAbs = nowYear * 12 + nowMonth;
    const selectedAbs = selectedYear * 12 + selectedMonth;

    if (selectedAbs >= nowAbs) return false;

    if (selectedAbs === nowAbs - 1) {
      return now.getDate() > 17;
    }

    return true;
  }

  disableVacationsButton() {
    return this.isInception || this.isPreviousMonthNotAllowed();
  }
}

export default RequestQuestionController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestQuestion/requestQuestion.controller.js